export const pluginId = 'Is-it-open';
